import * as Accordion from "@radix-ui/react-accordion";
import React from "react";
import SVG from "react-inlinesvg";
import ReactTooltip from "react-tooltip";
import { t } from "ttag";

import {
    CompareFeatureBlock,
    TsicommonCmsCompareFeatureOrNull,
} from "@reactivated";

import CaretDownIcon from "../../../../img/icons/caret-down.svg";
import QuestionMarkCircleIcon from "../../../../img/icons/question-mark-circle-filled.svg";
import { RichText } from "../../../common/RichText";
import { CompareFeatureRow } from "../elements/CompareFeatureRow";

import styles from "./index.module.scss";

interface ICompareFeaturesProps {
    features: TsicommonCmsCompareFeatureOrNull[];
    compareTileFeatures?: CompareFeatureBlock[][];
}

export const CompareFeatures = (props: ICompareFeaturesProps) => {
    if (!props.compareTileFeatures) {
        return null;
    }
    return (
        <div className={styles.compareFeaturesContainer}>
            <Accordion.Root
                type="multiple"
                defaultValue={props.features.map((ftr) => ftr?.title || "")}
            >
                {props.features.map((ftr, index) => {
                    if (!ftr) {
                        return null;
                    }

                    return (
                        <Accordion.Item
                            key={ftr.title}
                            value={ftr.title || ""}
                            className={styles.accordionItem}
                        >
                            <Accordion.Trigger>
                                <div className={styles.accordionTrigger}>
                                    <SVG
                                        src={CaretDownIcon}
                                        className={`arrow ${styles.accordionArrowIcon}`}
                                    />
                                    <div
                                        className={styles.accordionTriggerTitle}
                                    >
                                        {ftr.title || ""}
                                    </div>
                                    <sup>
                                        <span
                                            data-tip={true}
                                            data-for={`compare-feature-tooltip--${index}`}
                                            tabIndex={0}
                                        >
                                            <SVG
                                                className={styles.tooltipIcon}
                                                src={QuestionMarkCircleIcon}
                                            />
                                        </span>
                                        <ReactTooltip
                                            aria-label={t`Question mark icon`}
                                            class="tooltip"
                                            event="mouseover focus"
                                            eventOff="scroll mousewheel mouseleave mouseout blur"
                                            id={`compare-feature-tooltip--${index}`}
                                            place="right"
                                            role="tooltip"
                                            isCapture={true}
                                        >
                                            <RichText
                                                html={ftr.tooltip || ""}
                                            />
                                        </ReactTooltip>
                                    </sup>
                                </div>
                            </Accordion.Trigger>
                            <Accordion.Content>
                                <CompareFeatureRow
                                    feature={ftr}
                                    content={props.compareTileFeatures?.map(
                                        (ctf) =>
                                            ctf.find(
                                                (item) =>
                                                    item?.feature?.title ===
                                                    ftr.title,
                                            ) || null,
                                    )}
                                />
                            </Accordion.Content>
                        </Accordion.Item>
                    );
                })}
            </Accordion.Root>
        </div>
    );
};
